import { ILinkProps as IFluentLinkProps, Link as FluentLink } from 'office-ui-fabric-react';
import React, { ComponentProps, FunctionComponent } from 'react';
import { Link as ReactRouterLink, LinkProps as InternalLinkProps } from 'react-router-dom';
import styled, { css } from 'styled-components';

const linkStyle = css`
  color: rgb(0, 120, 212);
  text-decoration: none;

  &:active,
  &:hover {
    color: rgb(0, 69, 120);
    text-decoration: underline;
  }

  &:focus,
  &.ms-Link:focus {
    box-shadow: none;
    outline: 1px solid black;
  }
`;

export const InternalLink = styled(ReactRouterLink)`
  ${linkStyle}
`;

export const ExternalLink = styled(FluentLink)`
  ${linkStyle}
`;

export type ILinkProps = Partial<InternalLinkProps> | Partial<IFluentLinkProps>;

export const BaseLink: FunctionComponent<ILinkProps> = props => {
  const { to } = props;
  return to ? <InternalLink {...(props as InternalLinkProps)} /> : <ExternalLink {...(props as ComponentProps<typeof ExternalLink>)} />;
};

export default BaseLink;
